import CasesModule from '@/modules/cases/store';
import GlobalModule from '@/modules/global/store';
import LawsuitModule from '@/modules/lawsuit/store';
import LookupsModule from '@/modules/lookups/store';
import SystemModule from '@/modules/system/store';
import JudicialFeesModule from '@/modules/judicialFees/store';
import BankruptcyModule from '@/modules/bankruptcy/store';
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    CasesModule,
    GlobalModule,
    LawsuitModule,
    LookupsModule,
    SystemModule,
    JudicialFeesModule,
    BankruptcyModule,
  },
});
